import {useDocumentationLinks} from '../../../../../../provider/help-links/help-links-hook';
import {DocumentationLinksType} from '../../../../../../provider/help-links/help-links-type';
import {YANDEX_FOOD_CATALOG_ID, YANDEX_WEBMASTER_CATALOG_ID} from '../source-catalog-page-const';

import {HeaderAlertPropsType} from './header-alert';

type StringKeysOfType<T> = {[K in keyof T]: T[K] extends string ? K : never}[keyof T];

type CatalogHeaderAlertEntryType = {
    messageStringKey: HeaderAlertPropsType['messageStringKey'];
    linkStringKey: HeaderAlertPropsType['linkStringKey'];
    docLinkKey: StringKeysOfType<DocumentationLinksType>;
};

const CATALOG_HEADER_ALERTS: Record<string, CatalogHeaderAlertEntryType> = {
    [YANDEX_FOOD_CATALOG_ID]: {
        messageStringKey: 'SOURCE_SETTINGS__YANDEX_ALERT__MESSAGE',
        linkStringKey: 'SOURCE_SETTINGS__YANDEX_ALERT__MESSAGE__LINK',
        docLinkKey: 'sourceYandexLinking',
    },
    [YANDEX_WEBMASTER_CATALOG_ID]: {
        messageStringKey: 'SOURCE_SETTINGS__YANDEX_WEBMASTER_ALERT__MESSAGE',
        linkStringKey: 'SOURCE_SETTINGS__YANDEX_ALERT__MESSAGE__LINK',
        docLinkKey: 'sourceYandexWebmasterLinking',
    },
};

export function useCatalogHeaderAlertConfig(catalogId: string | number | undefined): HeaderAlertPropsType | null {
    const documentationLinks = useDocumentationLinks();
    const entry = CATALOG_HEADER_ALERTS[String(catalogId ?? '')];

    if (!entry) {
        return null;
    }

    return {
        messageStringKey: entry.messageStringKey,
        linkStringKey: entry.linkStringKey,
        linkHref: documentationLinks[entry.docLinkKey],
    };
}
